module.exports = __webpack_public_path__ + "static/media/ibm.08e786f2.png";